import { useEffect, useState, useRef } from 'react'
import { getNodeLabel } from 'Services/WeaverUtils'
import './HeadsUpDisplay.scss'

export default HeadsUpDisplay = ({ node }) ->

  [loading, setLoading] = useState(true)
  [data, setData] = useState(undefined)
  [visible, setVisible] = useState(false)

  attrListRef = useRef(undefined)
  lineHeight = 50

  useEffect( ->
    if data
      setVisible(true)
    else
      setVisible(false)
  , [data])

  useEffect( ->
    return setData(undefined) unless node
    setLoading(true)
    setData(undefined)
    ( ->
      dbNode = await Weaver.Node.load(node.id)
      setData(dbNode)
      setLoading(false)
    )()
    undefined
  , [node])

  getLine = (length, i) ->
    isEven = length % 2 is 0
    isTop = (length / 2) < i
    isBottom = (length / 2) > i

    offset = 100 + Math.floor(lineHeight / 2)

    if isEven
      if isTop
        y = ((((length / 2) - 0.5) - i) * lineHeight) + offset
      else
        y = ((i - ((length / 2) - 0.5)) * -lineHeight) + offset
    else
      if isTop
        y = ((Math.floor(length / 2) - i) * lineHeight) + offset
      else if isBottom
        y = ((i - Math.floor(length / 2)) * -lineHeight) + offset
      else
        y = offset

    <svg height="210" width="500" style={{ position: 'absolute', transform: 'translateY(-100px)' }}>
      <path
        className="hud-path"
        style={{ stroke: '#3a3a58', strokeWidth: 2 }}
        fill="none"
        d="M 9 #{y} L #{lineHeight} #{offset} L #{lineHeight * 2} #{offset}"
        strokeLinejoin="round"
      />
    </svg>



  if node?
    <div
      style={{
        width: '100%'
        height: '100%'
        position: 'absolute'
        zIndex: 9999
      }}
      className="vr-hud"
    >
      <div style={{
        background: '#000022'
        opacity: 0.5
        width: '100%'
        height: '100%'
      }} />
      <ul
        style={{
          color: 'white',
          fontSize: '1rem',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          left: '50%',
          marginBottom: 0,
          paddingLeft: 0,
          listStyleType: 'none'
        }}
        className={visible && 'visible' || ''}
        ref={attrListRef}
      >
        {
          attributes = _.pickBy(data?.attributes(), (val, key) -> val? and val isnt "")
          attributes.id = data?.id()

          _.map(attributes, (val, key) ->
            <li key={key}>
              { getLine(_.keys(attributes).length, _.keys(attributes).indexOf(key)) }
              <span className="attribute-item-container">
                <b>{ key }:</b> { val }
              </span>
            </li>
          )
        }
      </ul>
    </div>
  else
    <></>